module.exports = __webpack_public_path__ + "img/aball1_ks2.060dec13.png";